import React from 'react';

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Điều khoản sử dụng
        </h1>

        <div className="space-y-6 text-gray-700">
          <section>
            <p className="text-sm text-gray-500 mb-4">
              Cập nhật lần cuối: {new Date().toLocaleDateString('vi-VN')}
            </p>
            <p>
              Chào mừng bạn đến với <strong>Học nhé</strong>. Bằng việc sử dụng dịch vụ của chúng tôi,
              bạn đồng ý với các điều khoản dưới đây.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              1. Chấp nhận điều khoản
            </h2>
            <p>
              Khi truy cập và sử dụng blog Học nhé, bạn xác nhận rằng bạn đã đọc, hiểu và
              đồng ý bị ràng buộc bởi các điều khoản này. Nếu bạn không đồng ý, vui lòng
              không sử dụng dịch vụ.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              2. Tài khoản người dùng
            </h2>
            <p className="mb-2">Khi tạo tài khoản, bạn cam kết:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Cung cấp thông tin chính xác và đầy đủ</li>
              <li>Bảo mật thông tin đăng nhập của bạn</li>
              <li>Chịu tr책nhiệm cho mọi hoạt động dưới tài khoản của bạn</li>
              <li>Thông báo ngay cho chúng tôi nếu phát hiện truy cập trái phép</li>
              <li>Không chia sẻ tài khoản cho người khác</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              3. Nội dung người dùng
            </h2>
            <p className="mb-2">Khi đăng nội dung lên Học nhé, bạn đảm bảo rằng:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Bạn sở hữu hoặc có quyền sử dụng nội dung đó</li>
              <li>Nội dung không vi phạm bản quyền, thương hiệu của bên thứ ba</li>
              <li>Nội dung không chứa thông tin sai lệch, lừa đảo</li>
              <li>Nội dung không vi phạm pháp luật Việt Nam</li>
              <li>Nội dung không chứa virus, mã độc hại</li>
            </ul>
            <p className="mt-2">
              Bạn vẫn giữ quyền sở hữu nội dung của mình, nhưng cấp cho Học nhé quyền
              sử dụng, hiển thị và phân phối nội dung đó trên nền tảng.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              4. Hành vi bị cấm
            </h2>
            <p className="mb-2">Bạn không được phép:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Đăng nội dung vi phạm pháp luật, khiêu dâm, bạo lực, kỳ thị</li>
              <li>Spam, quảng cáo trái phép</li>
              <li>Mạo danh người khác hoặc tổ chức</li>
              <li>Can thiệp vào hoạt động của hệ thống</li>
              <li>Thu thập thông tin người dùng khác trái phép</li>
              <li>Sử dụng bot, script để tự động hóa trái phép</li>
              <li>Tấn công, hack hoặc làm gián đoạn dịch vụ</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              5. Quyền của Học nhé
            </h2>
            <p className="mb-2">Chúng tôi có quyền:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Xóa hoặc chỉnh sửa nội dung vi phạm điều khoản</li>
              <li>Tạm ngưng hoặc chấm dứt tài khoản vi phạm</li>
              <li>Thay đổi, tạm ngưng hoặc ngừng cung cấp dịch vụ</li>
              <li>Từ chối dịch vụ với bất kỳ ai vì bất kỳ lý do gì</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              6. Sở hữu trí tuệ
            </h2>
            <p>
              Tất cả các thành phần của Học nhé (logo, thiết kế, mã nguồn, v.v.) đều thuộc
              quyền sở hữu của chúng tôi. Bạn không được sao chép, sửa đổi hoặc sử dụng
              chúng mà không có sự cho phép.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              7. Miễn trừ trách nhiệm
            </h2>
            <p>
              Dịch vụ được cung cấp "nguyên trạng". Chúng tôi không đảm bảo dịch vụ sẽ
              luôn hoạt động liên tục, không lỗi hoặc an toàn tuyệt đối. Chúng tôi không
              chịu trách nhiệm cho:
            </p>
            <ul className="list-disc list-inside space-y-1 ml-4 mt-2">
              <li>Mất mát dữ liệu hoặc lợi nhuận</li>
              <li>Gián đoạn dịch vụ</li>
              <li>Nội dung do người dùng tạo ra</li>
              <li>Hành vi của người dùng khác</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              8. Giới hạn trách nhiệm
            </h2>
            <p>
              Trách nhiệm của chúng tôi đối với bạn, trong mọi trường hợp, sẽ không vượt quá
              số tiền bạn đã trả cho dịch vụ (nếu có) trong 12 tháng trước đó.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              9. Thay đổi điều khoản
            </h2>
            <p>
              Chúng tôi có thể cập nhật các điều khoản này theo thời gian. Việc bạn tiếp tục
              sử dụng dịch vụ sau khi có thay đổi đồng nghĩa với việc bạn chấp nhận các
              điều khoản mới.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              10. Luật áp dụng
            </h2>
            <p>
              Các điều khoản này được điều chỉnh bởi pháp luật Việt Nam. Mọi tranh chấp sẽ
              được giải quyết tại tòa án có thẩm quyền tại Việt Nam.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              11. Liên hệ
            </h2>
            <p>
              Nếu bạn có câu hỏi về điều khoản sử dụng, vui lòng liên hệ:
            </p>
            <ul className="list-none space-y-1 ml-4 mt-2">
              <li>Email: <a href="mailto:borostudio2018@gmail.com" className="text-blue-600 hover:underline">borostudio2018@gmail.com</a></li>
              <li>Website: <a href="https://blog.hocnhe.com" className="text-blue-600 hover:underline">https://blog.hocnhe.com</a></li>
            </ul>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600 text-center">
              © {new Date().getFullYear()} Học nhé. Tất cả các quyền được bảo lưu.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
